import React, { Component } from 'react';
import { format_date_technical } from '../../functions/functions_formatting.js';
import ForminputDropdown from '../forminput/forminput_dropdown.js';
import ForminputText from '../forminput/forminput_text.js';
import ForminputDate from '../forminput/forminput_date.js';


export default class Userlist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                user_id_min: "",
                user_id_max: "",
                username: "",
                name: "",
                badges: "",
                country: "",
                hometown: "",
                created_from: "",
                created_to: "",
                trips_count_min: "",
                trips_count_max: ""
            },
            filter_reset_counter: 0,
            show_filters: false
        };
        this.setFilter = this.setFilter.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.setDropdownFilter = this.setDropdownFilter.bind(this);
        this.toggleFilters = this.toggleFilters.bind(this);
    }


    setFilter(name, value) {
        this.setState((prevState) => ({
            filters: {
                ...prevState.filters,
                [name]: value
            }
        }));
    }


    clearFilters() {
        this.setState({
            filters: {
                user_id_min: "",
                user_id_max: "",
                username: "",
                name: "",
                badges: "",
                country: "",
                hometown: "",
                created_from: "",
                created_to: "",
                trips_count_min: "",
                trips_count_max: ""
            },
            filter_reset_counter: this.state.filter_reset_counter + 1
        });
    }


    setDropdownFilter(name, value) {
        if (value === "Any") {
            this.setFilter(name, "");
            return;
        }
        this.setFilter(name, value);
    }


    toggleFilters() {
        this.setState((prevState) => ({
            show_filters: !prevState.show_filters
        }));
    }


    render() {
        var enableFilters = this.props.enableFilters === true;
        var userdata = this.props.userdata || [];
        var filters = this.state.filters;
        var filterResetCounter = this.state.filter_reset_counter;
        var showFilters = this.state.show_filters;
        var tripsPerUser = (this.props.tripdata || []).reduce((countMap, tripElement) => {
            var ownerId = String(tripElement.owner_id || "");
            if (!ownerId) {
                return countMap;
            }
            countMap[ownerId] = (countMap[ownerId] || 0) + 1;
            return countMap;
        }, {});

        var includesText = (fieldValue, filterValue) => {
            var value = String(fieldValue || "").toLowerCase();
            var query = String(filterValue || "").toLowerCase();
            return value.includes(query);
        };
        var matchDropdownValue = (fieldValue, selectedValue) => {
            if (!selectedValue) {
                return true;
            }
            return String(fieldValue || "") === String(selectedValue);
        };
        var matchArrayContainsValue = (arrayValue, selectedValue) => {
            if (!selectedValue) {
                return true;
            }
            if (!Array.isArray(arrayValue)) {
                return false;
            }
            return arrayValue.some((value) => String(value || "") === String(selectedValue));
        };

        var inNumericRange = (value, minValue, maxValue) => {
            var numericValue = Number(value);
            if (isNaN(numericValue)) {
                return false;
            }
            if (minValue !== "" && numericValue < Number(minValue)) {
                return false;
            }
            if (maxValue !== "" && numericValue > Number(maxValue)) {
                return false;
            }
            return true;
        };
        var matchesDateRange = (value, fromValue, toValue) => {
            if (!fromValue && !toValue) {
                return true;
            }
            if (!value) {
                return false;
            }
            var valueDate = new Date(value);
            if (isNaN(valueDate.getTime())) {
                return false;
            }
            if (fromValue) {
                var fromDate = new Date(fromValue);
                fromDate.setHours(0, 0, 0, 0);
                if (valueDate < fromDate) {
                    return false;
                }
            }
            if (toValue) {
                var toDate = new Date(toValue);
                toDate.setHours(23, 59, 59, 999);
                if (valueDate > toDate) {
                    return false;
                }
            }
            return true;
        };
        var countryOptions = [...new Set(userdata.map((element) => String(element.country || "").trim()).filter((element) => element.length >= 1))]
            .sort((a, b) => a.localeCompare(b));
        var hometownOptions = [...new Set(userdata.map((element) => String(element.hometown || "").trim()).filter((element) => element.length >= 1))]
            .sort((a, b) => a.localeCompare(b));
        var badgeOptions = [...new Set(userdata.flatMap((element) => (Array.isArray(element.badges) ? element.badges : []).map((badgeElement) => String(badgeElement || "").trim())).filter((element) => element.length >= 1))]
            .sort((a, b) => a.localeCompare(b));

        var filteredData = userdata.filter((userElement) => {
            var tripsCount = tripsPerUser[String(userElement.user_id)] || 0;
            if (!inNumericRange(userElement.user_id, filters.user_id_min, filters.user_id_max)) return false;
            if (!includesText(userElement.username, filters.username)) return false;
            if (!includesText(userElement.name, filters.name)) return false;
            if (!matchArrayContainsValue(userElement.badges, filters.badges)) return false;
            if (!matchDropdownValue(userElement.country, filters.country)) return false;
            if (!matchDropdownValue(userElement.hometown, filters.hometown)) return false;
            if (!matchesDateRange(userElement.created, filters.created_from, filters.created_to)) return false;
            if (!inNumericRange(tripsCount, filters.trips_count_min, filters.trips_count_max)) return false;
            return true;
        });

        return (
            <div className="admindashboard__section">
                <div className="admindashboard__section__title text-title">
                    Users
                </div>
                <div className="admindashboard__section__content">
                    {enableFilters &&
                        <div className="admindashboard__section__content__element">
                            <div onClick={this.toggleFilters} className={("button " + (showFilters ? "button-primary-light" : "button-primary"))}>
                                {showFilters ? "Hide filters" : "Show filters"}
                            </div>
                            <div>
                                {filteredData.length + " / " + userdata.length + " users"}
                            </div>
                        </div>
                    }

                    {enableFilters && showFilters &&
                        <div className="admindashboard__section__content__element">
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "8px" }}>
                                <ForminputText
                                    key={"user_id_min-" + filterResetCounter}
                                    name={"user_id_min"}
                                    label={""}
                                    default_value={filters.user_id_min || ""}
                                    placeholder={"User ID from"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"user_id_max-" + filterResetCounter}
                                    name={"user_id_max"}
                                    label={""}
                                    default_value={filters.user_id_max || ""}
                                    placeholder={"User ID to"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"username-" + filterResetCounter}
                                    name={"username"}
                                    label={""}
                                    default_value={filters.username || ""}
                                    placeholder={"Username"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"name-" + filterResetCounter}
                                    name={"name"}
                                    label={""}
                                    default_value={filters.name || ""}
                                    placeholder={"Full name"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputDropdown
                                    key={"badges-" + filterResetCounter + "-" + filters.badges}
                                    name={"badges"}
                                    label={""}
                                    list={["Any", ...badgeOptions]}
                                    default_value={filters.badges || ""}
                                    placeholder={"Badge"}
                                    setFormValue={this.setDropdownFilter}
                                    required={false}
                                />
                                <ForminputDropdown
                                    key={"country-" + filterResetCounter + "-" + filters.country}
                                    name={"country"}
                                    label={""}
                                    list={["Any", ...countryOptions]}
                                    default_value={filters.country || ""}
                                    placeholder={"Country"}
                                    setFormValue={this.setDropdownFilter}
                                    required={false}
                                />
                                <ForminputDropdown
                                    key={"hometown-" + filterResetCounter + "-" + filters.hometown}
                                    name={"hometown"}
                                    label={""}
                                    list={["Any", ...hometownOptions]}
                                    default_value={filters.hometown || ""}
                                    placeholder={"Hometown"}
                                    setFormValue={this.setDropdownFilter}
                                    required={false}
                                />
                                <ForminputDate
                                    key={"created_from-" + filterResetCounter}
                                    name={"created_from"}
                                    label={"Created from"}
                                    default_value={filters.created_from || ""}
                                    placeholder={"Created from"}
                                    note={""}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputDate
                                    key={"created_to-" + filterResetCounter}
                                    name={"created_to"}
                                    label={"Created to"}
                                    default_value={filters.created_to || ""}
                                    placeholder={"Created to"}
                                    note={""}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"trips_count_min-" + filterResetCounter}
                                    name={"trips_count_min"}
                                    label={""}
                                    default_value={filters.trips_count_min || ""}
                                    placeholder={"Trips from"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"trips_count_max-" + filterResetCounter}
                                    name={"trips_count_max"}
                                    label={""}
                                    default_value={filters.trips_count_max || ""}
                                    placeholder={"Trips to"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                            </div>
                            <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "12px" }}>
                                <button type="button" onClick={this.clearFilters} className="button button-light">
                                    Clear filters
                                </button>
                            </div>
                        </div>
                    }

                    {(userdata && userdata.length >= 1) &&
                        <>
                            <div style={{ overflowX: "auto" }}>
                                <div className="admindashboard__section__content__table" style={{ gridTemplateColumns: "0.7fr 1fr 1fr 1fr 1fr 1fr 0.7fr", minWidth: "980px" }}>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        User ID
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Username
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Full name
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Country
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Hometown
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Created
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Trips
                                    </div>

                                    {filteredData.map((userElement, i) => {
                                        var userId = userElement.user_id;
                                        return (
                                            <React.Fragment key={i}>
                                                <div onClick={() => this.props.setUser(userId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {userElement.user_id ? userElement.user_id : "-"}
                                                </div>
                                                <div onClick={() => this.props.setUser(userId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {userElement.username ? userElement.username : "-"}
                                                </div>
                                                <div onClick={() => this.props.setUser(userId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {userElement.name ? userElement.name : "-"}
                                                </div>
                                                <div onClick={() => this.props.setUser(userId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {userElement.country ? userElement.country : "-"}
                                                </div>
                                                <div onClick={() => this.props.setUser(userId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {userElement.hometown ? userElement.hometown : "-"}
                                                </div>
                                                <div onClick={() => this.props.setUser(userId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {userElement.created ? format_date_technical(userElement.created) : "-"}
                                                </div>
                                                <div onClick={() => this.props.setUser(userId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {tripsPerUser[String(userElement.user_id)] || 0}
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}

                                </div>
                            </div>

                            {filteredData.length < 1 &&
                                <div style={{ marginTop: "12px" }}>
                                    No users match the current filters.
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
        )
    }
}
